export default __webpack_public_path__ + "static/media/w_f_2025_h.fa40b44c.jpg";